<modal
  [id]="modalId()"
  [header]="'v2.orgSettings.billing.paymentCardsModalTitle'"
  [headerIcon]="headerIcon()"
  [closeButtonEnabled]="true"
  [enableBackdropClose]="true"
  [showHeaderDivider]="true"
  [showFooterDivider]="false"
  [heightClass]="'tw-h-fit tw-max-h-[90vh]'"
  [widthClass]="'tw-w-11/12 md:tw-w-3/4 lg:tw-w-1/2 xl:tw-w-3xl tw-max-w-xl'"
  (onCloseModal)="close()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-gap-4 tw-pb-2">
    <div class="tw-flex tw-flex-col tw-gap-3">
      @for (method of paymentMethods(); track method.id) {
        <div
          class="tw-relative tw-flex tw-items-center tw-justify-between tw-gap-4 tw-p-3 lg:tw-p-4 tw-rounded-xl tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-transition-opacity"
          [ngClass]="{
            'tw-bg-gray-100 dark:tw-bg-gray-800/60': isExpired(method),
            'tw-bg-white dark:tw-bg-gray-800': !isExpired(method),
            'tw-pointer-events-none': isRemoving(method),
            'hover:tw-border-gray-400': !isRemoving(method)
          }"
        >
          <div class="tw-flex tw-items-center tw-gap-4 tw-min-w-0">
            <div
              class="tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center tw-w-16 lg:tw-w-20 tw-h-9 lg:tw-h-10 tw-bg-white tw-rounded-lg tw-overflow-hidden"
            >
              <img
                [src]="getCardBrandIconUrl()(method.brand)"
                alt=""
                class="tw-w-full tw-h-full tw-object-contain"
              />
            </div>

            <div class="tw-flex tw-flex-col tw-w-full tw-min-w-0">
              <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
                <p class="tw-font-inter tw-font-semibold tw-text-sm lg:tw-text-base tw-leading-6 tw-text-gray-900 dark:tw-text-gray-100 tw-truncate">
                  {{ formatCardBrand()(method.brand) }} •••• {{ method.last4 }}
                </p>
              </div>

              @if (isExpired(method)) {
                <p class="tw-font-inter tw-font-medium tw-text-xs lg:tw-text-sm tw-leading-5 tw-text-red-600">
                  {{ 'v2.orgSettings.billing.cardExpired' | translate }}
                </p>
              } @else {
                <p class="tw-font-inter tw-font-normal tw-text-xs lg:tw-text-sm tw-leading-5 tw-text-gray-500 dark:tw-text-gray-400">
                  {{ 'v2.orgSettings.billing.cardExpiryDate' | translate }}: {{ formatCardExpiry()(method.exp_month, method.exp_year) }}
                </p>
              }
            </div>
          </div>

          <div class="tw-flex tw-items-center tw-gap-3 tw-shrink-0">
            @if (isDefault(method)) {
              <span class="tw-inline-flex tw-items-center tw-rounded-md tw-bg-blue-50 tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-text-blue-700">
                {{ 'v2.orgSettings.billing.defaultPaymentCard' | translate }}
              </span>
            }

            @if (shouldShowActions(method)) {
              <app-dropdown
                [dropdownOptions]="getCardMenuOptions(method)"
                [widthInPX]="'220px'"
                [minWidthInPX]="'200px'"
                [heightInPX]="0"
                [maxHeightInPX]="240"
                [dropdownListXPosition]="'left'"
                [dropdownListYPosition]="'bottom'"
                (optionClicked)="onMenuOptionClicked($event, method)"
              >
                <button
                  type="button"
                  class="tw-inline-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-lg hover:tw-bg-gray-100 dark:hover:tw-bg-gray-700 tw-transition-colors"
                  [attr.aria-label]="'v2.orgSettings.billing.cardActions' | translate"
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path
                      d="M10 10.8333C10.4602 10.8333 10.8333 10.4602 10.8333 10C10.8333 9.53976 10.4602 9.16667 10 9.16667C9.53976 9.16667 9.16667 9.53976 9.16667 10C9.16667 10.4602 9.53976 10.8333 10 10.8333Z"
                      stroke="#6B7280"
                      stroke-width="1.8"
                    />
                    <path
                      d="M10 5C10.4602 5 10.8333 4.6269 10.8333 4.16667C10.8333 3.70643 10.4602 3.33333 10 3.33333C9.53976 3.33333 9.16667 3.70643 9.16667 4.16667C9.16667 4.6269 9.53976 5 10 5Z"
                      stroke="#6B7280"
                      stroke-width="1.8"
                    />
                    <path
                      d="M10 16.6667C10.4602 16.6667 10.8333 16.2936 10.8333 15.8333C10.8333 15.3731 10.4602 15 10 15C9.53976 15 9.16667 15.3731 9.16667 15.8333C9.16667 16.2936 9.53976 16.6667 10 16.6667Z"
                      stroke="#6B7280"
                      stroke-width="1.8"
                    />
                  </svg>
                </button>
              </app-dropdown>
            }
          </div>

          @if (isRemoving(method)) {
            <div
              class="tw-absolute tw-inset-0 tw-z-10 tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-bg-white/80 dark:tw-bg-gray-900/70"
              aria-live="polite"
              [attr.aria-label]="'v2.orgSettings.billing.removingPaymentCard' | translate"
            >
              <div
                class="tw-w-8 tw-h-8 tw-border-2 tw-border-gray-200 tw-border-t-blue-600 tw-rounded-full tw-animate-spin"
                aria-hidden="true"
              ></div>
            </div>
          }
        </div>
      }
    </div>

    <div class="tw-pt-2">
      <button
        type="button"
        class="tw-w-full tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-h-12 tw-rounded-xl tw-border tw-border-blue-600 tw-text-blue-700 hover:tw-bg-blue-50 dark:hover:tw-bg-blue-900/10 tw-transition-colors tw-font-inter tw-font-medium tw-text-base"
        (click)="openAddNew()"
      >
        <span class="tw-inline-flex tw-items-center tw-justify-center tw-w-4 tw-h-4">
          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M10 4.16667V15.8333" stroke="#1C64F2" stroke-width="2" stroke-linecap="round" />
            <path d="M4.16669 10H15.8334" stroke="#1C64F2" stroke-width="2" stroke-linecap="round" />
          </svg>
        </span>
        <span class="tw-text-base tw-leading-6">{{ 'v2.orgSettings.billing.addNewPaymentCard' | translate }}</span>
      </button>
    </div>
  </div>
</modal>

@if (isRemoveConfirmModalOpen()) {
  <delete-modal
    [id]="removePaymentCardConfirmModalId()"
    [message]="removePaymentCardConfirmMessage()"
    [confirmBtnLabel]="'v2.orgSettings.billing.removePaymentCardConfirmYes' | translate"
    [cancelBtnLabel]="'v2.orgSettings.billing.removePaymentCardConfirmCancel' | translate"
    (onDelete)="confirmRemovePaymentCard()"
    (onCancel)="closeRemoveConfirm()"
  ></delete-modal>
}

